<template>
    <div
        v-cloak
        v-if="projects && projects.length"
        class="article-projects"
    >
        <a
            v-for="(project) in visibleProjects"
            :key="project.id"
            :href="projectUrl(project)"
            target="_blank"
            class="article-project"
        >
            <i class="fa-light fa-house-building"/>
            <h6>{{ project.name }}</h6>
            <span>{{ bundle.id_11024 }}</span>
        </a>

        <button
            v-if="hasMore && !showAll"
            type="button"
            @click.prevent="showAll = true"
            class="more-article-projects"
        >
            <i class="fa-light fa-plus"></i>
            {{ bundle.id_12558 }}
        </button>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: "article-projects",
    props: {
        projects: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            max: 3,
            showAll: false,
            bundle: {
                id_11024: "/project",
                id_11770: "View project",
                id_12558: "Show more"
            }
        };
    },
    created() {
        Vue.$bundle("portal", this.bundle, (bundle) => {
            this.bundle = bundle;
        });
    },
    computed: {
        hasMore() {
            return this.projects.length > this.max;
        },
        visibleProjects() {
            return this.showAll
                ? this.projects
                : this.projects.slice(0, this.max);
        }
    },
    methods: {
        projectUrl(project) {
            return `${this.bundle.id_11770}/project/${project.id}`;
        }
    }
};
</script>

<style scoped lang="less">
[v-cloak] {
    display: none;
}
</style>